export const GLOBAL_CONSTANTS = {
  CODE_SUCCESS: 1,
  MSG_SUCCESS: 'success',
  HTTP_STATUS_SUCCESS: 200,

  ERROR_RESPONSE_NOT_FOUND: '[ERROR] response not found',
  ERROR_JSON_DATA_NOT_FOUND: '[ERROR] JSON Data response not found',
  ERROR_DATA_FIELD_NOT_FOUND: '[ERROR] Data field not found',
};
